import api from './api';

export async function getNotifications({ page = 1, limit = 20, readStatus = 'all' } = {}) {
  const params = { page, limit, readStatus };
  const response = await api.get('/admin/notifications', { params });
  return response.data;
}

export async function getUnreadNotificationCount() {
  const response = await api.get('/admin/notifications/unread-count');
  return response.data;
}

export async function markAllNotificationsAsRead() {
  const response = await api.patch('/admin/notifications/read-all');
  return response.data;
}

export function extractCount(payload) {
  if (typeof payload === 'number') return payload;
  if (typeof payload?.count === 'number') return payload.count;
  if (typeof payload?.unreadCount === 'number') return payload.unreadCount;
  if (typeof payload?.data === 'number') return payload.data;
  if (typeof payload?.data?.count === 'number') return payload.data.count;
  if (typeof payload?.data?.unreadCount === 'number') return payload.data.unreadCount;
  return 0;
}
